import React, { Component } from 'react';
import { Form, message, Modal, Table } from 'antd';

import { connect } from 'react-redux';

import moment from 'moment';

import util from '@util';
import { queryFundsRecordIncome, querySaveFundsRecordRelate } from '@api/finance/funds';

class ModalRelate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      condition: '',
      pageNo: 1,
      data: [],
    };
  }

  componentWillMount() {
    this.setState({ uuid: this.props.uuid });
    this.loadIncomeList(1);
  }

  loadIncomeList = pageNo => {
    const params = {};
    params.condition = this.state.condition;
    params.compUuid = this.props.funds_book.companyUuid;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 10;
    params.start = current;
    this.setState({
      pageNo: current,
    });
    queryFundsRecordIncome(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  saveFundsRecordRelate = incomeUuid => {
    const { uuid } = this.state;
    const { handleSubmit } = this.props;

    const params = {};
    params.uuid = uuid;
    params.incomeUuid = incomeUuid;
    querySaveFundsRecordRelate(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        handleSubmit();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: 250,
        render: text => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        key: 'accountName',
        width: 200,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
      },
      {
        title: '收入(元)',
        dataIndex: 'money',
        key: 'money',
        width: 200,
        render: text => (
          <a style={{ color: 'green' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: '支出(元)',
        dataIndex: 'payMoney',
        key: 'payMoney',
        width: 200,
        render: text => (
          <a style={{ color: 'red' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          return <a onClick={() => this.saveFundsRecordRelate(record.uuid)}>选择</a>;
        },
      },
    ];
  };

  render() {
    const { data } = this.state;

    const pagination = {
      defaultPageSize: 10,
      showSizeChanger: false,
      onChange: current => {
        this.loadIncomeList(current);
      },
      current: this.state.pageNo,
      total: this.state.total,
    };

    return (
      <Modal title="关联的银行流水" visible width="900" onCancel={this.props.cancel}>
        <Table
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          rowKey="uuid"
          scroll={{ y: scrollY }}
        />
      </Modal>
    );
  }
}

export default connect(state => ({
  funds_book: state.funds_book,
}))(Form.create({ wrappedComponentRef: true })(ModalRelate));



// WEBPACK FOOTER //
// ./src/components/finance/funds/detail/ModalRelate.js